// External libraries
import gql from 'graphql-tag';

export const APPROVE_ONBOARD_PAYMENT_MUTATION = gql`
  mutation ApproveOnboardPaymentMutation(
    $token: String!
    $instrumentId: String
    $isBillingAgreement: Boolean!
  ) {
    attemptSetStickyFi(token: $token, instrumentId: $instrumentId)
      @include(if: $isBillingAgreement) {
      buyer {
        userId
      }
    }
    approveGuestSignUpPayment(token: $token) {
      buyer {
        userId
      }
      cart {
        paymentId
        returnUrl {
          href
        }
      }
    }
  }
`;
